import { useEffect, useState } from 'react'
import type { Translations } from '@/i18n/translations'

/** Unix seconds, ticking once a minute — enough for "in 2 hours". */
export function useNow(): number {
  const [now, setNow] = useState(() => Math.floor(Date.now() / 1000))
  useEffect(() => {
    const id = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 60_000)
    return () => clearInterval(id)
  }, [])
  return now
}

export function clock(ts: number): string {
  return new Date(ts * 1000).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
}

/** Weekday, day of month and short month, from the calendar translations. */
export function dayParts(ts: number, T: Translations) {
  const d = new Date(ts * 1000)
  return {
    weekday: T.calendar.days[(d.getDay() + 6) % 7],   // the table starts on Monday
    day: d.getDate(),
    month: T.calendar.monthsShort[d.getMonth()],
  }
}

/** How far off a match is, in the words a player would use. */
export function relativeTo(ts: number, now: number, T: Translations): string {
  const diff = ts - now
  if (diff <= 0) return diff > -3 * 3600 ? T.matches.relLive : T.matches.relPlayed
  if (diff < 3600) return T.matches.relMinutes.replace('{n}', String(Math.max(1, Math.round(diff / 60))))
  const start = new Date(ts * 1000)
  const today = new Date(now * 1000)
  const days = Math.round(
    (new Date(start.getFullYear(), start.getMonth(), start.getDate()).getTime()
      - new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime()) / 86_400_000,
  )
  if (days === 0) return T.matches.relHours.replace('{n}', String(Math.round(diff / 3600)))
  if (days === 1) return T.matches.relTomorrow
  return T.matches.relDays.replace('{n}', String(days))
}
